<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="JobsV2"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="jobs-v2"
    :headerTitle="'Jobs'|pgettext('Jobs')"
    :items="ds"
    checkbox-row-selection
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <PageHelp
        path="/general/jobs.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "jobs-v2",
    path: "/jobs-v2",
    component: "JobsV2"
  }
)

@Component()
export default class JobsV2 extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('browse_a_job')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "number",
          name: this.$fn.pgettext("Jobs", "Number"),
          type: "command",
          formatter: [{
            name: "template",
            format: "#{{ number }}",
          }
            ,
          {
            name: "link",
            href: "#",
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "parent_number",
          name: this.$fn.pgettext("Jobs", "Parent"),
          type: "command",
          formatter: [{
            name: "template",
            format: "#{{ parent_number }}",
          }
            ,
          {
            name: "link",
            href: "#",
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "status",
          name: this.$fn.pgettext("Jobs", "Status"),
        }
          ,
        {
          field: "name",
          name: this.$fn.pgettext("Jobs", "Job type"),
        }
          ,
        {
          field: "bulk_job",
          name: this.$fn.pgettext("Jobs", "Bulk"),
          type: "boolean",
          formatter: "checkbox",
        }
          ,
        {
          field: "key",
          name: this.$fn.pgettext("Jobs", "Key"),
        }
          ,
        {
          field: "queue",
          name: this.$fn.pgettext("Jobs", "Queue"),
        }
          ,
        {
          field: "submit_time",
          name: this.$fn.pgettext("Jobs", "Submit time"),
          formatter: {
            name: "datetime",
          }
          ,
        }
          ,
        {
          field: "created_by",
          name: this.$fn.pgettext("Jobs", "Submitter"),
          formatter: {
            name: "user",
          }
          ,
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Jobs|Title", "Jobs"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3480_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3480, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_3482_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_3482, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_showModal_3484_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_3484, alias=undefined
    return {
      name: "Job",
      props: {
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_3483_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_3483, alias=undefined
    return $event.data.column.id === 'number'
  }

  async act_2248226175642056_showModal_3486_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_3486, alias=undefined
    return {
      name: "Job",
      props: {
        oid: $event.data.data.parent_id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_3485_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_3485, alias=undefined
    return $event.data.column.id === 'parent_number'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3480: actions.CloseModalAction;
    evh_7315092382398562_close_3479: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_3482: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_3481: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_showModal_3484: actions.ShowModalAction;
    evh_2248226175642056_command_3483: actions.EventHandlerImpl;
    act_2248226175642056_showModal_3486: actions.ShowModalAction;
    evh_2248226175642056_command_3485: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3480 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3480_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3479 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3480,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3479],
      }
    );
    const act_2248226175642056_setData_3482 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_3482_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_3481 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_3482,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_3481],
      }
    );
    const act_2248226175642056_showModal_3484 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_3484_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_3483 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_3484,
        event: "command",
        when: this.evh_2248226175642056_command_3483_getWhen,
        displayName: "showModal",
      }
    );
    const act_2248226175642056_showModal_3486 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_3486_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_3485 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_3486,
        event: "command",
        when: this.evh_2248226175642056_command_3485_getWhen,
        displayName: "showModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_3483, evh_2248226175642056_command_3485],
      }
    );
    return {
      act_7315092382398562_closeModal_3480,
      evh_7315092382398562_close_3479,
      evh_7315092382398562_close,
      act_2248226175642056_setData_3482,
      evh_2248226175642056_selectedRowsChanged_3481,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_showModal_3484,
      evh_2248226175642056_command_3483,
      act_2248226175642056_showModal_3486,
      evh_2248226175642056_command_3485,
      evh_2248226175642056_command,
    }
  }
}

Vue.component("JobsV2", JobsV2);

</script>